var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDepartment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 11.375V5.25H7V19.25H21V11.375H14.875ZM8.75 7H13.125V11.375H8.75V7ZM8.75 13.125H13.125V17.5H8.75V13.125ZM19.25 17.5H14.875V13.125H19.25V17.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 9.625H16.625V1.75H24.5V9.625ZM18.375 7.875H22.75V3.5H18.375V7.875ZM24.5 17.5H22.75V19.25H24.5V24.5H3.5V19.25H5.25V17.5H3.5C3.03587 17.5 2.59075 17.6844 2.26256 18.0126C1.93437 18.3408 1.75 18.7859 1.75 19.25V24.5C1.75 24.9641 1.93437 25.4092 2.26256 25.7374C2.59075 26.0656 3.03587 26.25 3.5 26.25H24.5C24.9641 26.25 25.4092 26.0656 25.7374 25.7374C26.0656 25.4092 26.25 24.9641 26.25 24.5V19.25C26.25 18.7859 26.0656 18.3408 25.7374 18.0126C25.4092 17.6844 24.9641 17.5 24.5 17.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 22.75C6.60825 22.75 7 22.3582 7 21.875C7 21.3918 6.60825 21 6.125 21C5.64175 21 5.25 21.3918 5.25 21.875C5.25 22.3582 5.64175 22.75 6.125 22.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartment);
export default __webpack_public_path__ + "static/media/department.c38cb9e4015f8e67451f4f5c3a75cf0c.svg";
export { ForwardRef as ReactComponent };